import { TableSorting } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';

export const transformSortBy = (sortBy?: TableSorting[] | undefined) => {
	if (!sortBy || sortBy.length === 0) {
		return undefined;
	}
	return {
		key: sortBy[0].key,
		desc: sortBy[0].desc ?? false,
	};
};
